export const WIDGET_TYPES = [
  { value: "recent_posts", label: "Postări recente" },
  { value: "categories", label: "Categorii" },
  { value: "tags", label: "Tag-uri" },
  { value: "stats", label: "Statistici Forum" },
  { value: "profile", label: "Profil user" },
  { value: "calendar", label: "Calendar" },
  { value: "online_users", label: "Useri online" },
  { value: "top_users", label: "Top useri" },
  { value: "html", label: "HTML custom" },
  { value: "chatbox", label: "Chat Box" },
  { value: "radio", label: "Radio Player" },
  { value: "popular_contributors", label: "Popular Contributors" },
  { value: "time_online", label: "Time Spent Online" },
  { value: "recent_statuses", label: "Recent Status Updates" },
  { value: "important_topics", label: "Important Topics" },
  { value: "promoted_topics", label: "Promoted Topics" },
  { value: "server_status", label: "🎮 Status Servere" },
];

export const POSITIONS = [
  { value: "above_boards", label: "Deasupra la categorii" },
  { value: "top", label: "Top sidebar" },
  { value: "middle", label: "Middle sidebar" },
  { value: "bottom", label: "Bottom sidebar" },
  { value: "below_boards", label: "Sub categorii" },
];

export const VISIBILITY = [
  { value: "all", label: "Toți" },
  { value: "guest", label: "Doar oaspeți" },
  { value: "user", label: "Doar logați" },
  { value: "vip", label: "Doar VIP" },
  { value: "admin", label: "Doar admin" },
];

export const newWidget = (position = "middle", type = "recent_posts") => ({
  type,
  position,
  title: "",
  settings: { items_count: 5, show_date: true, show_author: true, visibility: "all" },
  enabled: true,
  order: 99,
});
